import { OnInit, OnDestroy } from '@angular/core';
import { Router } from '@angular/router';
import { Data, JWT } from '../../helpers';
import { DashboardService } from '../../dashboard';
import { ErrorHandlerService } from '../../services';
import { Observable } from 'rxjs/Rx';
var GmailConnectionsComponent = /** @class */ (function () {
    function GmailConnectionsComponent(data, dashboardService, errorHandlerService, router) {
        this.data = data;
        this.dashboardService = dashboardService;
        this.errorHandlerService = errorHandlerService;
        this.router = router;
        this.connections = [];
        this.msgTitle = "";
        this.msgContent = "";
        this.popUp = false;
        this.isGoogleAPIConnectionAvailable = true;
        this.googleAPIConnectionId = -1;
        this.isGoogleAPIAuthorizationDeclined = false;
        this.showSpinner = false;
        this.showOnlyOverlay = false;
        this.showErrorModalDialog = false;
        this.showErrorMessages = [""];
        this.showErrorMessageTitle = "Error!";
        this.showErrorMessageWidthInPercentage = "20%";
        this.subscriptions = [];
        this.isSessionExpired = false;
        this.isGoogleContactsAvailable = false;
    }
    GmailConnectionsComponent.prototype.editDisplay = function (isGoogleContactsAvailable) {
        if (isGoogleContactsAvailable) {
            return "block";
        }
        else {
            return "none";
        }
    };
    GmailConnectionsComponent.prototype.ngOnInit = function () {
        this.updateIsGoogleAPIConnectionAvailable();
    };
    GmailConnectionsComponent.prototype.openGoogleContactAuthWindowIfRequired = function () {
        var _this = this;
        // If Google Authorization has NOT been performed by the user previously, redirect her to the Google Auth page
        if (this.isGoogleAPIConnectionAvailable == false) {
            this.showSpinner = true;
            var url = process.env.API_URL + "/redirectToGoogleAuthorization.do?jwtToken=" + encodeURIComponent(JWT.jwtToken());
            console.log("the Google Authorization URL = " + url);
            var width = 400;
            var height = 600;
            var leftPosition = (window.screen.width / 2) - ((width / 2) + 10);
            //Allow for title and status bars.
            var topPosition = (window.screen.height / 2) - ((height / 2) + 50);
            this.googleAuthWindow = window.open(url, "Authenticate with Google", "width=" + width + ",height=" + height + ",left=" + leftPosition + ",top=" + topPosition);
            // Poll and check if the Google Authorization is complete
            this.googleContactsAuthWindowOpenCheckerSubscriber = Observable.interval(3000).subscribe(function (x) {
                _this.checkGoogleAuthorizationCompletionStatus();
            });
        }
        else {
            // Else just fetch the Contacts.
            console.log("The Google API Connectiion is avaialble, about to fetch Google Contacts");
            this.fetchGoogleContacts();
        }
    };
    GmailConnectionsComponent.prototype.checkGoogleAuthorizationCompletionStatus = function () {
        var _this = this;
        var s1 = this.dashboardService.loggedInUser().subscribe(function (data) {
            _this.googleAPIConnectionId = data.googleAPIConnectionId;
            _this.isGoogleAPIAuthorizationDeclined = data.isGoogleAPIAuthorizationDeclined;
            console.log("googleAPIConnectionId, isGoogleAPIAuthorizationDeclined from loggedInUser API ==>"
                + _this.googleAPIConnectionId + ", " + _this.isGoogleAPIAuthorizationDeclined);
            if (_this.isGoogleAPIAuthorizationDeclined) {
                _this.googleContactsAuthWindowOpenCheckerSubscriber.unsubscribe();
                _this.showSpinner = false;
                _this.googleAuthWindow.close();
                // Display a Modal Dialog saying that the Google Authorization was declined. Route back to Home Page after that.
            }
            else {
                // If the Authorization was Successful and a Google Connecton could be obtained, fetch the Contacts.
                if (_this.googleAPIConnectionId !== null && _this.googleAPIConnectionId >= 0) {
                    _this.googleContactsAuthWindowOpenCheckerSubscriber.unsubscribe();
                    _this.googleAuthWindow.close();
                    console.log("The Google API Connectiion ID is " + _this.googleAPIConnectionId + ", about to fetch Google Contacts");
                    _this.fetchGoogleContacts();
                }
            }
        }, function (error) {
            _this.handleError(error);
            console.log(error);
        });
        this.subscriptions.push(s1);
    };
    GmailConnectionsComponent.prototype.updateIsGoogleAPIConnectionAvailable = function () {
        var _this = this;
        var s2 = this.dashboardService.loggedInUser().subscribe(function (data) {
            _this.isGoogleAPIConnectionAvailable = data.isGoogleAPIConnectionAvailable;
            console.log("this.isGoogleAPIConnectionAvailable from loggedInUser API ==>" + _this.isGoogleAPIConnectionAvailable);
            // open a Google auth window if required
            _this.openGoogleContactAuthWindowIfRequired();
        }, function (error) {
            _this.handleError(error);
            console.log(error);
        });
        this.subscriptions.push(s2);
    };
    GmailConnectionsComponent.prototype.fetchGoogleContacts = function () {
        var _this = this;
        console.log("Fetching Google Contacts");
        this.showSpinner = true;
        this.dashboardService.gmailContacts().subscribe(function (res) {
            _this.connections = res;
            _this.isGoogleContactsAvailable = true;
            console.log('Connections');
            console.log(_this.connections);
            _this.showSpinner = false;
        }, function (error) {
            _this.showSpinner = false;
            _this.handleError(error);
        });
    };
    GmailConnectionsComponent.prototype.fetchContactsInNextPage = function () {
        var _this = this;
        this.showSpinner = true;
        var s3 = this.dashboardService.gmailNextContacts(this.connections).subscribe(function (res) {
            _this.connections = res;
            console.log('Connections in Next Page');
            console.log(_this.connections);
            _this.showSpinner = false;
        }, function (error) {
            _this.showSpinner = false;
            _this.handleError(error);
        });
        this.subscriptions.push(s3);
    };
    GmailConnectionsComponent.prototype.fetchContactsInPreviousPage = function () {
        var _this = this;
        this.showSpinner = true;
        var s4 = this.dashboardService.gmailPrevContacts(this.connections).subscribe(function (res) {
            _this.connections = res;
            console.log('Connections in Previous Page');
            console.log(_this.connections);
            _this.loading = false;
            _this.showSpinner = false;
        }, function (error) {
            _this.showSpinner = false;
            _this.handleError(error);
        });
        this.subscriptions.push(s4);
    };
    GmailConnectionsComponent.prototype.inviteClick = function () {
        var _this = this;
        console.log(this.connections);
        this.showSpinner = true;
        var s5 = this.dashboardService.gmailInviteSent(this.connections).subscribe(function (res) {
            _this.connections = res;
            _this.showSpinner = false;
            _this.createInfoAlert("Invitation sent out successfully to selected contacts.");
        }, function (error) {
            _this.showSpinner = false;
            _this.handleError(error);
        });
        this.subscriptions.push(s5);
    };
    GmailConnectionsComponent.prototype.createInfoAlert = function (alert) {
        var infoAlert = {
            isInfo: true,
            infoMessage: alert,
            url: "not required"
        };
        this.handleError(infoAlert);
    };
    GmailConnectionsComponent.prototype.handleError = function (error) {
        console.log("The error inside the Error Handler==>" + error);
        var url = error.url;
        console.log("The URL of the error==>" + error.url);
        if (url == undefined) {
            return;
        }
        console.log("Throwing the error now. Shall call the errorHandlerService throwError method");
        this.errorHandlerService.throwError(error);
    };
    GmailConnectionsComponent.prototype.ngOnDestroy = function () {
        this.subscriptions.forEach(function (element) {
            element.unsubscribe();
        });
    };
    return GmailConnectionsComponent;
}());
export { GmailConnectionsComponent };
//# sourceMappingURL=gmailconnections.component.js.map